
export const VA_UPDATE_STATE = "VA_UPDATE_STATE"
export const VA_CREATED = "VA_CREATED"
export const VA_UPDATED = "VA_UPDATED"
export const VA_UPDATION = "VA_UPDATION"